import React from 'react'

const App: React.FC = () => {
  return <h1>Hello Sasho!</h1>
}

export default App
